import { render, staticRenderFns } from "./AddEntrance.vue?vue&type=template&id=8d187eaa&scoped=true&"
import script from "./AddEntrance.vue?vue&type=script&lang=js&"
export * from "./AddEntrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d187eaa",
  null
  
)

export default component.exports